let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("11LfB")).then(() => parcelRequire('8xiBH'));